<template lang="pug">
  .component-client-action-buttons(v-if="entity")
    ul.dropdown.menu(v-if="item && canDo", data-dropdown-menu='', v-f="")
      li
        a(href='#Item-1') Action
        ul.menu
          li(v-if="canActivate")
            a(v-on:click="activate") Activate
          li(v-if="canSuspend")
            a(v-on:click="suspend") Suspend
          li(v-if="canDelete")
            a(v-on:click="deleteClient") Delete
          li(v-if="canEdit")
            a(v-on:click="edit") Edit
          li(v-if="canDump")
            a(v-on:click="dump") Dump Data
          li
            registration-token-reveal(:item="entity")


    .dropdown-buttons(v-else-if="canDo")
      button.button.success(type="button", v-on:click="activate", v-if="canActivate") Activate
      button.button.warning(type="button", v-on:click="suspend", v-if="canSuspend") Suspend
      button.button.alert(type="button", v-on:click="deletec", v-if="canDelete") Delete

    .dropdown-buttons(v-else)
      p No actions available

</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import MaggieHelper from "src/maggieHelper";
  import ClientSmartEdit from "../../../backoffice/smartedits/ClientEdit";
  import ModalReveal from "../../foundation/ModalReveal";
  import RegistrationTokenReveal from "./reveal/ApplyRegistrationTokenReveal";

  export default {
    name: "ClientActionButtons",
    components: {
      RegistrationTokenReveal,
      ModalReveal,
      ClientSmartEdit,
    },
    data() {
      return {
        entity: null,
        registrationTokens:[]
      }
    },
    created() {
      if (!this.client) {
        KeplerBackofficeSdk.clients.select(this.$route.params.id).get((item) => {
          this.entity = item
        })
      } else {
        this.entity = this.client
      }
    },
    methods: {
      activate() {
        KeplerBackofficeSdk.clients.select(this.entity).activate((response) => {
          this.entity = response
          MaggieHelper.notification('activate-esit', "Client activated")
          location.reload()
        })
      },
      suspend() {
        this.$confirm('Are you sure?', 'Do you really want to suspend this client?', () => {
          KeplerBackofficeSdk.clients.select(this.entity).suspend((response) => {
            this.entity = response
            MaggieHelper.notification('suspend-esit', "Client suspended")
          })
        })
      },
      deleteClient() {
        this.$confirm('Are you sure?', 'Do you really want to delete this client?', () => {
          KeplerBackofficeSdk.clients.select(this.entity).delete((response) => {
            this.entity = response
            MaggieHelper.notification('delete-esit', "client deleted")
          })
        })
      },
      edit() {
        MaggieHelper.openRightPanel({
          component: ClientSmartEdit, props: {
            item: this.entity
          }
        })
      },
      dump() {
        KeplerBackofficeSdk.clients.select(this.entity).dump((response) => {
          navigator.clipboard.writeText(JSON.stringify(response)).then(function () {
            MaggieHelper.notification('Copied', 'Client data copied to clipboard.')
          }, function (err) {
            console.error('Async: Could not copy text: ', err)
          })
        })
      },
    },
    computed: {
      canActivate() {
        return this.$acl('activate-clients') && (this.entity.status === 'ON HOLD' || this.entity.status === 'SUSPENDED')
      },
      canSuspend() {
        return this.$acl('suspend-clients') && this.entity.status === 'ACTIVE'
      },
      canDelete() {
        return this.$acl('delete-clients') && (this.entity.status === 'SUSPENDED' || this.entity.status === 'ON HOLD')
      },
      canEdit() {
        return this.$acl('edit-clients')
      },
      canDump() {
        return this.$acl('dump-client')
      },
      canDo() {
        return this.canActivate || this.canSuspend || this.canDelete || this.canEdit || this.canDump
      }
    },
    props: ['client', 'item']
  }
</script>



// WEBPACK FOOTER //
// ClientActionButtons.vue?4dee2dc5